import { ApiService } from './../../services/api.service';
import { UtilService } from './../../services/util.service';
import { Component, OnInit, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppSettings } from 'src/app/services/AppSettings';
import { CommonSkeletonComponent } from '../../skeleton/common-skeleton/common-skeleton.component';
import { LangdingPageNavBarComponent } from '../langding-page-nav-bar/langding-page-nav-bar.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [CommonModule, NgbModule, CommonSkeletonComponent, LangdingPageNavBarComponent,
    NG_ICON_DIRECTIVES,
  ],
  schemas: [NO_ERRORS_SCHEMA],
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
  faqresponse:any;
  title="General";
  creditData:any=[];
  getName:any =AppSettings;
  loadAPIcall:boolean=false;
  activeAccordionIndex: number | null = 0; // Default first item open

  titleList=[]
  constructor(
     private api: ApiService,
    private util: UtilService,
    ) { }

  ngOnInit() {
   this.FAQList('General');
   this.creditConsumptions();
   }

   creditConsumptions(){
    var profiledata: any = {}
    profiledata.userId = localStorage.getItem('userId')
    profiledata.userType = localStorage.getItem('userType')
    this.util.startLoader()
    this.api.create('user/profileDetails', profiledata).subscribe(res => {
      this.util.stopLoader();

      this.creditData=res.data.creditConsumptions;

    })
   }

  getelement(key){
   return this.creditData.find(item => item.creditType === key);
  }

   clickitem(item,index){
    this.title=item;

    if(item==='GigSumo Credits'){
         this.FAQList('Credits');
    }
    else if(item==='General'){
         this.FAQList('General');
    }
    else if(item==='Referral FAQ'){
         this.FAQList('Referal_FAQ');
    }

  }

  FAQList(module) {
    let data: any = {};
    data.module = module;
    // this.util.startLoader();
    this.loadAPIcall=true;

    this.api.create("home/findFAQs", data).subscribe(
      (res) => {
        // this.util.stopLoader();
        this.loadAPIcall=false;

        if (res.code == "00000") {
          this.faqresponse = res.data;
          if(module==''){
            this.titleList=[];
            this.faqresponse.faqList.forEach(element => {
            this.titleList.push(element.module);
            this.removeDuplicates(this.titleList)

            });

          }
        }
      },
      (err) => {
        this.util.stopLoader();
      }
    );
  }

  removeDuplicates(arr) {
    return arr.filter((item,
        index) => arr.indexOf(item) === index);
  }

  // Toggle accordion panel
  toggleAccordion(index: number): void {
    this.activeAccordionIndex = this.activeAccordionIndex === index ? null : index;
  }
}
